export default function (Component) {
Component.options.__title = "Time Item as a set of Time"
}